import v5_model from '@/models/v5/model';

var Notification = v5_model.extend({
    defaults: {
        id: null,
    },

    initialialize: function() {
        this.type = Notification.type;
    }

});

Notification.type = 'notification';

export default Notification;


